import V2 from "./v2/error";

export default function Entry(props) {
    return <V2 {...props} />;
}
